import { render, staticRenderFns } from "./1087415.vue?vue&type=template&id=3d679de4"
import script from "./1087415.vue?vue&type=script&lang=js"
export * from "./1087415.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports